import { servicesAPI } from "./api"
import { parseServicesCallbackWithValue } from "./api/services"
import { Smartlist } from "../models"
import { ViewMenuResponse } from "./models/datalist"

enum GetSmartlistsPath {
    Private = "CollectPrivateSmartlists",
    SharedByMe = "CollectSharedByMeSmartlists",
    SharedWithMe = "CollectSharedWithMeSmartlists",
}

const getSmartlists = (
    path: GetSmartlistsPath,
    filter = "",
    offset = 0,
    limit = 25,
): Promise<Smartlist[]> => servicesAPI.postJSON(path, { filter, offset, limit })

export const getPrivateSmartlists = (
    filter: string,
    offset: number,
    limit: number,
): Promise<Smartlist[]> =>
    getSmartlists(GetSmartlistsPath.Private, filter, offset, limit)

export const getSharedByMeSmartlists = (
    filter: string,
    offset: number,
    limit: number,
): Promise<Smartlist[]> =>
    getSmartlists(GetSmartlistsPath.SharedByMe, filter, offset, limit)

export const getSharedWithMeSmartlists = (
    filter: string,
    offset: number,
    limit: number,
): Promise<Smartlist[]> =>
    getSmartlists(GetSmartlistsPath.SharedWithMe, filter, offset, limit)

export const getViewMenuItems = (
    selectionFilterId?: string,
    viewType?: number,
): Promise<ViewMenuResponse> =>
    servicesAPI.postJSON(
        "GetViewMenuItems",
        { selectionFilterId, viewType },
        parseServicesCallbackWithValue<ViewMenuResponse>,
    )
